<template>
  <div>
    <FixedButton>
      <el-button type="primary" @click.stop="add" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <Dialog :row="row" v-if="visible" @refresh="formSearch" :visible.sync="visible" />
  </div>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@manage/mixins/formTableMixin'
import Dialog from './dialog'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '编辑',
          type: 'edit'
        },
        {
          name: '删除',
          type: 'delete'
        },
        {
          name: '下载',
          type: 'download'
        }
      ],
      queryApi: this.$api.system.appVersion_list,
      visible: false,
      row: {}
    }
  },
  components: {
    Dialog
  },
  methods: {
    formSearch(data) {
      this.search(data, null, this.queryApi)
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm('是否删除该APP版本', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.system.appVersion_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDownload(row) {
      window.open('/api/' + this.$api.common.file_read + '?id=' + row.fileId)
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'download':
          this.handleDownload(row)
          break
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
